import { useEffect, useState } from "react";
import Loading from "../components/Loading/Loading";
import {
  makeStyles,
  Grid,
  TextField,
  Button,
  MenuItem,
} from "@material-ui/core";
import CustomButton from "../components/common/controls/CustomButton";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import DMModal from "../components/common/controls/DMModal";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import * as discountAction from "../actions/discountAction";
import { connect } from "react-redux";
import "./pageStyles.scss";
import { deleteDiscountService } from "../services/DiscountService";
import { DELETE_SERVICE_ERROR_MESSAGE } from "../utilities/applicationutils";

var CONTROLS_DATA = require("./ControlsData.json");
var MODELS_CONTROLS = CONTROLS_DATA.SCREENS.MODELS;

const Discount = ({
  discountState,
  getDiscounts,
  getDiscountsListData,
  createDiscount,
  updateDiscount,
  deleteDiscount,
  renderDiscountsListData,
  getTransactionTypes,
  TransactionTypeState,
  updateState,
  modelState,
  deleteModel,
  setSnackBar,
}) => {
  const [discountData, setDiscountData] = useState([]);
  const [discountId, setDiscountId] = useState("");
  const [discountLabel, setDiscountLabel] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [transactionTypeId, setTransactionTypeId] = useState("");
  const [showNewModel, setShowNewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const newDiscountOnClick = () => { 
    setDiscountLabel(""); 
    setDiscountPercentage(""); 
    setTransactionType(""); 
    setShowNewModel(true);
  }

  const handleChange = (value) => {
    setSortBy(value);
  };

  const discountJson = [
    {
      discountId: "1",
      discountLabel: "20% off First Year Fee",
      discountPercentage: "20",
      transactionTypeId: "2",
    },
    {
      discountId: "2",
      discountLabel: "50% off First Year Fee",
      discountPercentage: "50",
      transactionTypeId: "2",
    },
    {
      discountId: "3",
      discountLabel: "100% off First Year Fee and Renewal",
      discountPercentage: "100",
      transactionTypeId: "4",
    },
    {
      discountId: "4",
      discountLabel: "Multi-License Discount, 50% off",
      discountPercentage: "50",
      transactionTypeId: "2",
    },
  ];

  const transactionTypeJson = [
    {
      transactionTypeId: "1",
      transactionTypeText: "Renewal",
    },
    {
      transactionTypeId: "2",
      transactionTypeText: "New License",
    },
    {
      transactionTypeId: "3",
      transactionTypeText: "Trial License",
    },
    {
      transactionTypeId: "4",
      transactionTypeText: "New and Renewal License",
    },
  ];

  const handleDiscount = async () => {
    if(discountLabel && discountPercentage){
    try {
      const payload = {
        discountLabel: discountLabel,
        discountPercentage: discountPercentage,
        transactionTypeId: transactionType,
      };
      await createDiscount(payload);
      await getDiscounts();
      setSnackBar(true, "success", `Created new discount ${discountLabel}`);
      setLoading(false);
      setShowNewModel(false);
    } catch (error) {
      setShowNewModel(false);
      setSnackBar(
        true,
        "error",
        `Error while creating a new discount ${discountLabel}`
      );
    }
    }
    else {
      setSnackBar(true, "error", `Please enter Discount Name and Discount percentage!`);
      setLoading(false);
    }
  };

  const onEdit = (dId, cName, cSymbol, transactionText) => {
    setShowEditModel(true);
    setDiscountId(dId);
    setDiscountLabel(cName);
    setDiscountPercentage(cSymbol);
    const transactionId = TransactionTypeState.find((transaction) => transaction.transactionTypeText === transactionText);
    setTransactionType(transactionId.transactionTypeId);
  };

  const handleEditDiscount = async () => {
    try {
      const payload = {
        discountId: discountId,
        discountLabel: discountLabel,
        discountPercentage: discountPercentage,
        transactionTypeId: transactionType
      };
      await updateDiscount(discountId, payload);
      await getDiscounts();
      setSnackBar(true, "success", `Update new discount ${discountLabel}`);
      setLoading(false);
      setShowEditModel(false);
    } catch (error) {
      setShowEditModel(false);
      setSnackBar(true, "error", `Error while updating a new update`);
    }
  };

  const onDelete = (dId, dLabel) => {
    setDiscountId(dId);
    setDiscountLabel(dLabel);
    setShowDelete(true);
  };

  const deleteConfirm = async (model) => {
    try {
      const payload = {
        discountId: discountId,
      };
      await deleteDiscountService(payload.discountId).then( async (response) => {
      await getDiscounts();
      setSnackBar(true, "success", `${discountLabel} has been deleted.`);
      setLoading(false);
      setShowDelete(false);
    })
    .catch((error) =>{
      setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
      setLoading(false);
      setShowDelete(false);
    })
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `Error while deleting discount ${discountLabel}`
      );
    }
  };

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "40% 30% 25% 5%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  const classes = useStyles();

  const [modalStyle] = useState(getModalStyle);

  const updatePropertyName = (inputArray, oldPropertyName, newPropertyName) => {
    const updatedArray = inputArray?.map((obj) => {
      const { [oldPropertyName]: propertyValue, ...rest } = obj;
      return {
        [newPropertyName]: propertyValue,
        ...rest,
      };
    });
    return updatedArray;
  };

  const handleTransactionTypeModel = (e) => {
    setTransactionType( e.target.value );
  };

  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        await Promise.all([getDiscounts(), getTransactionTypes()]);
      } catch (error) {
        console.log("get discounts fails", error);
      }
    };
    fetchDiscount();
  }, [getDiscounts, getTransactionTypes]);

  useEffect(() => {
    if(discountState.length>0 && TransactionTypeState.length>0){
   const filteredDiscountData = discountState &&
      discountState.map((discount) => {
        const transactionType = TransactionTypeState.find(
          (type) => type.transactionTypeId === discount.transactionTypeId
        );
        return {
          discountId: discount.discountId,
          discountLabel: discount.discountLabel,
          discountPercentage: discount.discountPercentage,
          transactionTypeText: transactionType? transactionType.transactionTypeText: null,
          transactionTypeId: transactionType? transactionType.transactionTypeId: ""
        };
      });
      getDiscountsListData(filteredDiscountData);
    }
  }, [discountState, TransactionTypeState]);

  useEffect(() => {
    
    const ctrlData = [];
    renderDiscountsListData.length>0 && renderDiscountsListData.forEach((model) => {
      ctrlData.push({
        rowKey: model.discountId,
        discountLabel: model.discountLabel,
        discountPercentage: model.discountPercentage,
        transactionTypeText: model.transactionTypeText,
        rowValue: [
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.discountLabel,
              tab: "discounts",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.discountPercentage+ "%",
              tab: "discounts",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.transactionTypeText,
              tab: "discounts",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-actions",
            colOptions: [
              {
                name: "edit",
                tab: "discounts",
                action: () =>
                  onEdit(
                    model.discountId,
                    model.discountLabel,
                    model.discountPercentage,
                    model.transactionTypeText,
                    model.transactionTypeId
                  ),
                width: "100px",
              },
              {
                name: "delete",
                action: () => onDelete(model.discountId, model.discountLabel),
              },
            ],
          },
        ],
      });
    });
    setGridData(ctrlData);
  }, [renderDiscountsListData, sortBy]);

  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={12} md={11} className="page-content">
        <Grid item container xs={12} md={12} justify="flex-end">
          <CustomButton
            id="newModel"
            showGradient={true}
            variant="contained"
            color="primary"
            disabled={false}
            name="Add Discount"
            onClick={newDiscountOnClick}
          />
        </Grid>
        <Grid item container xs={12} md={10}>
          {gridData?.length > 0 && (
            <DMGrid
              key={Math.random()}
              headers={MODELS_CONTROLS.DISCOUNT_HEADER}
              headerClassName={classes.gridHeaderColumns}
              data={gridData}
              loading={loading}
              // selectedPage={modelState.selectedPage}
              // onPageSelection={onSelectedPage}
              setGridData={(t) => {
                setGridData(t);
              }}
            />
          )}
        </Grid>
        <DMModal open={showNewModel} onClose={() => setShowNewModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">New Discount</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id="outlined-basic-userName"
                label="Discount Name"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={discountLabel}
                onChange={(e) => setDiscountLabel(e.target.value)}
              />
              <TextField
                id="outlined-basic-userEmail"
                label="Discount Percentage"
                variant="outlined"
                type="text"
                InputProps={{
                  autoComplete: 'off',
                }}
                value={discountPercentage}
                onChange={(e) => setDiscountPercentage(e.target.value)}
              />
              <TextField
                id=""
                select
                labelId="region-name-select-required-label"
                label={"Transaction Type"}
                variant="outlined"
                value={transactionType}
                onChange={(e) => setTransactionType(e.target.value)}
                placeholder="Transaction Type"
              >
                {updatePropertyName(
                  TransactionTypeState,
                  "transactionTypeText",
                  "label"
                ).map((transaction) => {
                  return (
                    <MenuItem
                      key={transaction.transactionTypeId}
                      value={transaction.transactionTypeId}
                    >
                      {transaction.label}
                    </MenuItem>
                  );
                })}
              </TextField>
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setShowNewModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleDiscount}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMModal open={showEditModel} onClose={() => setShowEditModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">Edit Discount</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id="outlined-basic-userName"
                label="Discount Name"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={discountLabel}
                onChange={(e) => setDiscountLabel(e.target.value)}
              />
              <TextField
                id="outlined-basic-userEmail"
                label="Discount Percentage"
                variant="outlined"
                autoComplete="off"
                type="email"
                value={discountPercentage}
                onChange={(e) => setDiscountPercentage(e.target.value)}
              />
              <TextField
                id=""
                select
                labelId="region-name-select-required-label"
                label={"Transaction Type"}
                variant="outlined"
                value={transactionType}
                onChange={handleTransactionTypeModel}
                placeholder="Transaction Type"
              >
                {TransactionTypeState.map((transaction) => {
                  return (
                    <MenuItem value={transaction.transactionTypeId}>
                      {transaction.transactionTypeText}
                    </MenuItem>
                  );
                })}
              </TextField>
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setShowEditModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleEditDiscount}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMDeleteDialog
          open={showDelete}
          onClose={() => setShowDelete(false)}
          // title={"Are you sure to delete?"}
          contentText={`${discountLabel} will be deleted.`}
          discardText={"Cancel"}
          agreeText={"OK"}
          onProceed={() => {
            deleteConfirm(discountLabel);
          }}
        />
      </Grid>
    </div>
  );
};
const mapStateToProps = (state) => ({
  discountState: state.discount.discounts.data,
  renderDiscountsListData: state.discount.renderDiscountsListData || [],
  TransactionTypeState: state.discount.transactionTypes.data,
  updateState: state.discount.updateDiscount.data,
  modelState: state.model,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDiscounts: async () => dispatch(discountAction.getDiscounts()),
    getTransactionTypes: async () => dispatch(discountAction.getTransactionTypes()),
    getDiscountsListData: async (renderDiscountsListData) =>
      dispatch(discountAction.getDiscountsListData(renderDiscountsListData)),
    createDiscount: async (requestPayload) =>
      dispatch(discountAction.createDiscount(requestPayload)),
    updateDiscount: async (discountId,requestPayload) =>
      dispatch(discountAction.updateDiscount(discountId,requestPayload)),
    deleteDiscount: async (requestPayload) =>
      dispatch(discountAction.deleteDiscount(requestPayload)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Discount);
